__turbopack_context__.v({
  "UiButton": "_2H9vkq_UiButton",
  "UiButton__icon": "_2H9vkq_UiButton__icon",
  "UiMain": "_2H9vkq_UiMain",
  "UiSplide__arrows": "_2H9vkq_UiSplide__arrows",
  "UiSplide__arrows__button": "_2H9vkq_UiSplide__arrows__button",
  "UiSplide__track": "_2H9vkq_UiSplide__track",
  "UiSplide__track__slide": "_2H9vkq_UiSplide__track__slide",
  "UiText__body": "_2H9vkq_UiText__body",
  "UiText__lg": "_2H9vkq_UiText__lg",
  "UiTimeline": "_2H9vkq_UiTimeline",
  "UiTimeline__grid": "_2H9vkq_UiTimeline__grid",
  "UiTimeline__grid__image": "_2H9vkq_UiTimeline__grid__image",
  "UiTimeline__grid__item": "_2H9vkq_UiTimeline__grid__item",
  "UiTimeline__grid__text": "_2H9vkq_UiTimeline__grid__text",
  "UiTimeline__grid__title": "_2H9vkq_UiTimeline__grid__title",
  "UiTimeline__ul": "_2H9vkq_UiTimeline__ul",
  "UiTimeline__ul__li": "_2H9vkq_UiTimeline__ul__li",
  "UiTimeline__ul__li__scroll": "_2H9vkq_UiTimeline__ul__li__scroll",
  "UiTimeline__ul__li__scroll__span": "_2H9vkq_UiTimeline__ul__li__scroll__span",
});
